<template>
  <div>
    {{ submitted }}/{{ sourced }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      submitted: null,
      sourced: null
    };
  },
  beforeMount() {
    this.submitted = this.params.data.submitted;
    this.sourced = this.params.data.sourced;
  }

};
</script>
